import { Autocomplete, TextField } from "@mui/material";
import { NetworkFiltersState } from "../../../hooks/useNetworkFiltersState";

interface Option {
  label: string;
  value: string | number;
}

interface FilterAutocompleteProps {
  options: Array<{ label: string; value: string | number }>;
  value: string | undefined;
  filterKey: "location" | "nationality" | "gender" | "verificationStatus" | "limit" | "offset";
  width: string;
  placeholder: string;
  disabled: boolean;
  updateFilters: (key: keyof NetworkFiltersState, value: string) => void;
}

const styles = {
  autocomplete: {
    "& .MuiAutocomplete-input": {
      right: "3px !important",
    },
  },
  textField: {
    "& .MuiAutocomplete-input": {
      paddingRight: "12px !important",
    },
  },
} as const;

const FilterAutocomplete = ({
  options,
  value,
  filterKey,
  width,
  placeholder,
  disabled,
  updateFilters,
}: FilterAutocompleteProps) => {
  return (
    <Autocomplete
      disablePortal
      disabled={disabled}
      options={options}
      value={options.find((opt: Option) => opt.value == value) || null}
      onChange={(_, option: Option | null) => {
        updateFilters(filterKey, option?.value.toString() || "");
      }}
      sx={{
        width,
        ...styles.autocomplete,
      }}
      renderInput={(params) => <TextField sx={styles.textField} {...params} placeholder={placeholder} />}
    />
  );
};

export default FilterAutocomplete;
